import HashgateLogo from "../assets/experience/hashgate_logo.jpeg"
import VtuLogo from "../assets/experience/vtu_logo.jpg"
import NissiLogo from "../assets/experience/nissisoftwaresystems_logo.jpeg"
import PermusLogo from "../assets/experience/permus.jpeg"

const timeLineElement = [
    {
        id: 1,
        title: "Sri Sairam College of Engineering",
        location: "Visvesvaraya Technological University",
        description: "Bachelor of Technology in Computer Science and Engineering",
        buttonText: "View",
        date: "2016 - 2020",
        icon: "school",
        link:"https://sairamce.edu.in/",
        imag: VtuLogo
    },
    {
        id: 2,
        title: "Nissi Software Systems",
        location: "Software Engineer",
        description: "Developed cross-platform mobile applications using Flutter framework. Integrated RESTful APIs for data retrieval and management. Utilized state management techniques such as Provider and Bloc for efficient application state handling",
        buttonText: "View",
        date: "Feb 2021 - Mar 2023",
        icon: "work",
        link: "https://www.linkedin.com/company/nissisoftwaresystems/",
        imag: NissiLogo
    },
    {
        id: 3,
        title: "Hashgate IT Technologies",
        location: "Flutter Developer",
        description: "Collaborated with cross-functional teams to deliver high-quality Flutter applications meeting strict dead- lines.Experience with state management solutions such as Riverpod, Bloc, and GetX.Managed project tasks and timelines efficiently using project management tools like Jira or Trello",
        buttonText: "View",
        date: "May 2023 - Apr 2025",
        icon: "work",
        link: "https://www.linkedin.com/company/hashgate/",
        imag: HashgateLogo
    },
    {
        id: 4,
        title: "Permus Software House",
        location: "Flutter Developer",
        description: "Worked on developing and maintaining multiple CAFM mobile applications for end-to-end facility operations. Built scalable, role-based solutions for task management, service requests, inspections, and team coordination. Implemented real-time chat and live updates using Pusher, push notifications, geolocation tracking, and optimized performance across platforms.",
        date: "Apr 2025 - Present",
        icon: "work",
        link: "https://www.linkedin.com/company/permus/",
        imag: PermusLogo
    },
];

export default timeLineElement;
